module.exports = flarum.reg.get('core', 'common/query/IGambit');